import { addDays, startOfWeek } from 'date-fns';

export const TIME_SLOT_CONFIG = {
  startHour: 0,
  endHour: 23,
  slotDurationMinutes: 60,
  defaultScrollToHour: 6
};

/**
 * Generates an array of time slots for the weekly view
 * @param {number} startHour - Starting hour (0-23)
 * @param {number} endHour - Ending hour (0-23)
 * @param {number} durationMinutes - Duration of each slot in minutes
 * @returns {Array<{hour: number, minute: number}>}
 */
export function generateTimeSlots(
  startHour = TIME_SLOT_CONFIG.startHour,
  endHour = TIME_SLOT_CONFIG.endHour,
  durationMinutes = TIME_SLOT_CONFIG.slotDurationMinutes
) {
  const slots = [];
  let currentHour = startHour;
  let currentMinute = 0;

  while (currentHour < endHour || (currentHour === endHour && currentMinute === 0)) {
    slots.push({ hour: currentHour, minute: currentMinute });

    currentMinute += durationMinutes;
    while (currentMinute >= 60) {
      currentMinute -= 60;
      currentHour += 1;
    }
  }

  return slots;
}

/**
 * Generates an array of 7 days starting from the week containing the given date
 * @param {Date} currentDate - Any date within the desired week
 * @returns {Date[]} - Array of 7 Date objects representing the week
 */
export function generateWeekDays(currentDate) {
  const weekStart = startOfWeek(currentDate);
  const days = [];

  for (let i = 0; i < 7; i++) {
    days.push(addDays(weekStart, i));
  }

  return days;
}

/**
 * Formats hour to display string (e.g., "6 AM", "12 PM", "3 PM")
 * @param {number} hour - Hour in 24-hour format (0-23)
 * @returns {string}
 */
export function formatHour(hour) {
  if (hour === 0) return '12 AM';
  if (hour === 12) return '12 PM';
  if (hour < 12) return `${hour} AM`;
  return `${hour - 12} PM`;
}
